// extracted by mini-css-extract-plugin
export default {"productBodyCont":"ProductPageBody_productBodyCont__9clMI","productBodyDesc":"ProductPageBody_productBodyDesc__DJo8I","productBodyReview":"ProductPageBody_productBodyReview__0ePnF"};